var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChannels(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 40,
    viewBox: "0 0 40 40",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#374151",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.33
  }, /*#__PURE__*/React.createElement("path", {
    d: "m33.3333 11.6665h-26.66671c-1.84095 0-3.33334 1.4924-3.33334 3.3333v18.3334c0 1.8409 1.49239 3.3333 3.33334 3.3333h26.66671c1.8409 0 3.3333-1.4924 3.3333-3.3333v-18.3334c0-1.8409-1.4924-3.3333-3.3333-3.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.3334 3.3335-8.3333 8.3333-8.3334-8.3333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannels);
export default __webpack_public_path__ + "static/media/channels.537911e3025d700a4e5cd03f668ab372.svg";
export { ForwardRef as ReactComponent };